import { render } from "./CTABackgroundModule.vue?vue&type=template&id=ec26cb0e&scoped=true"
import script from "./CTABackgroundModule.vue?vue&type=script&lang=js"
export * from "./CTABackgroundModule.vue?vue&type=script&lang=js"

import "./CTABackgroundModule.vue?vue&type=style&index=0&id=ec26cb0e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec26cb0e"]])

export default __exports__